export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
      region: process.env.REACT_APP_AWS_COGNITO_REGION,
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_AWS_STORAGE_BUCKET_NAME,
      region: process.env.REACT_APP_AWS_STORAGE_REGION,
    },
  },
};
